(function () {
    'use strict';

    // @ngInject
    Services.Tippy = function Tippy($window) {

        return $window.tippy;
    };
}());
